// extracted by mini-css-extract-plugin
export var footer = "footer-module--footer--ov5Kw";
export var footerInner = "footer-module--footer-inner--8CB0T";
export var link = "footer-module--link--PM3ju";